import { render, staticRenderFns } from "./BP_PolicyPlanLocation.html?vue&type=template&id=18b947c5&external"
import script from "./BP_PolicyPlanLocation.vue?vue&type=script&lang=js"
export * from "./BP_PolicyPlanLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports